export const LS_NIGHTMODE = "SB_Nightmode"
